/**
 * PublishContentUseCase
 *
 * Orchestrates publishing a user-authored video: uploads the file to Firebase
 * Storage and triggers the `transcodeUserVideo` cloud function.
 *
 * Mirrors Flutter's `AppStorageService.uploadUserMedia` flow
 * (lib/services/app_storage_service.dart:26) minus trim/crop (not supported on
 * web) and chat/community-only helpers.
 */

import {
  userMediaService,
  type UserMediaService,
  type PublishContentOptions,
  type PublishContentResult,
} from '@/domain/services/userMedia/userMediaService';
import type { PublishContentRequest } from '@/domain/entities/publish/publishContentRequest';

export class PublishContentUseCase {
  constructor(private readonly service: UserMediaService = userMediaService) {}

  async execute(
    request: PublishContentRequest,
    options: PublishContentOptions = {},
  ): Promise<PublishContentResult> {
    return this.service.publishContent(request, options);
  }
}

export const publishContentUseCase = new PublishContentUseCase();
